import axios from "../utils/axios";
import { downloadByPost } from "../utils/download";

// 注册用户
export function register(params) {
  return axios.post("/auth/sto/register", params);
}

// 用户登录
export function login(params) {
  return axios.post("/v2/sto/auth/login", params);
  // return axios.post("/auth/login", params);
}

// 获取验证码
export function sendMsg(params) {
  const phonenumber = (params?.phonenumber || params?.username || "").trim();
  return axios.get("/v2/sto/auth/sms/code", { phonenumber });
}

// 校验验证码
export function updatePhone(params) {
  return axios.post("/v2/user/info/updatePhone", params);
}

// 修改手机号第一步校验
export function validateUpdatePhoneStep(params) {
  return axios.post("/v2/user/info/updatePhone/validateStep", params);
}

// 修改登录密码
export function updatePwd(params) {
  return axios.post("/v2/user/info/updatePassword", params);
}

// 登录店铺
export function loginShop(params) {
  return axios.post("/v2/sto/auth/shop", params);
}

// 兑换店铺一键登录 key
export function exchangeShopLoginKey(params) {
  return axios.post("/v2/sto/auth/login-key/exchange", params);
}

// 获取登录用户信息
export function getLoginInfo() {
  // return axios.get("/user/info/profile");
  return axios.getLogin("/v2/user/info/profile");
}

// 获取 OpenIM 签名
export function getOpenIMSign(params) {
  return axios.get("/v2/user/info/getOpenIMSign", params);
}

export function updateUserInfo(params) {
  return axios.post("/v2/user/info/updateProfile", params);
}

// 获取登录用户信息
export function wechatLogin(appId, code) {
  return axios.post(`/v2/sto/auth/wechat/user-info?appId=${appId}&code=${code}`);
}

// 获取店铺列表
export function getShopList(params) {
  return axios.get("/v2/store/shop/info/list", params);
}

// 获取当前登录店铺
export function getShopInfo() {
  return axios.get(`/v2/store/shop/info/showShop`);
}

// 获取店铺服务目录
export function getStoreServiceCatalog() {
  return axios.get("/v2/store/service/app/catalog");
}

// 获取店铺当前权益
export function getStoreServiceCurrentRights() {
  return axios.get("/v2/store/service/app/current-rights");
}

// 创建店铺服务订单
export function createStoreServiceOrder(params) {
  return axios.post("/v2/store/service/app/order/create", params);
}

// 查询店铺服务订单列表
export function getStoreServiceOrderList(params) {
  return axios.get("/v2/store/service/app/order/list", params);
}

// 查询店铺服务订单详情
export function getStoreServiceOrderDetail(orderNo) {
  return axios.get(`/v2/store/service/app/order/${orderNo}/show`);
}

// 查询支付结果
export function getStoreServicePayResult(orderNo) {
  return axios.get("/v2/store/service/app/order/payResult", { orderNo });
}

// 创建微信支付
export function createStoreServiceWechatPay(params) {
  return axios.post("/v2/store/service/app/payment/wechat/create", params);
}

// 创建支付宝支付
export function createStoreServiceAlipayPay(params) {
  return axios.post("/v2/store/service/app/payment/alipay/create", params);
}

// 查询流量账户
export function getStoreTrafficAccount() {
  return axios.get("/v2/store/traffic/account");
}

// 查询流量汇总
export function getStoreTrafficSummary() {
  return axios.get("/v2/store/traffic/summary");
}

// 查询流量账单分页
export function getStoreTrafficBillPage(params) {
  return axios.get("/v2/store/traffic/bill/page", params);
}

// 导出流量账单
export function exportStoreTrafficBill(params) {
  return downloadByPost(
    "/v2/store/traffic/bill/export",
    params,
    "流量账单.xlsx",
  );
}

// 查询流量消耗详情分页
export function getStoreTrafficDetailPage(params) {
  return axios.get("/v2/store/traffic/detail/page", params);
}

// 导出流量消耗详情
export function exportStoreTrafficDetail(params) {
  return downloadByPost(
    "/v2/store/traffic/detail/export",
    params,
    "流量消耗详情.xlsx",
  );
}

// 查询流量账户流水
export function getStoreTrafficFlowPage(params) {
  return axios.get("/v2/store/traffic/flow/page", params);
}

// 查询流量权益分页
export function getStoreTrafficRightsPage(params) {
  return axios.get("/v2/store/traffic/rights/page", params);
}

// 查询流量包列表
export function getStoreTrafficPackageList() {
  return axios.get("/v2/store/traffic/package/list");
}

// 创建流量包订单
export function createStoreTrafficPackageOrder(params) {
  return axios.post("/v2/store/traffic/package/order/create", params);
}

// 创建自定义流量充值订单
export function createStoreTrafficCustomPackageOrder(params) {
  return axios.post("/v2/store/traffic/package/custom/order/create", params);
}

// 查询资源中心账户概览
export function getStoreServiceResourceAccount(resourceType) {
  return axios.get("/v2/store/service/resource/account", { resourceType });
}

// 查询资源中心套餐列表
export function getStoreServiceResourcePackageList(resourceType) {
  return axios.get("/v2/store/service/resource/package/list", { resourceType });
}

// 创建资源中心充值订单
export function createStoreServiceResourcePackageOrder(params) {
  return axios.post("/v2/store/service/resource/package/order/create", params);
}

// 查询店铺资源账户列表
export function getStoreServiceAssetAccountList(params) {
  return axios.get("/v2/store/service/asset/account/list", params);
}

// 查询店铺资源账户流水
export function getStoreServiceAssetFlowList(params) {
  return axios.get("/v2/store/service/asset/flow/list", params);
}

// 查询店铺服务权益列表
export function getStoreServiceRightsList(params) {
  return axios.get("/v2/store/service/rights/list", params);
}

// 获取店铺看板概览
export function getShopDashboardOverview() {
  return axios.get("/v2/store/shop/dashboard/overview");
}

// 获取店铺直播分析概览
export function getShopLiveDashboardOverview() {
  return axios.get("/v2/store/shop/dashboard/live/overview");
}

// 获取店铺营收概况
export function getShopFinanceOverview(params) {
  return axios.get("/v2/store/shop/finance/overview", params);
}

// 获取店铺交易明细
export function findShopFinanceTradeDetailList(params) {
  return axios.get("/v2/store/shop/finance/trade-detail/list", params);
}

// 导出店铺交易明细
export function exportShopFinanceTradeDetail(params) {
  return downloadByPost(
    "/v2/store/shop/finance/trade-detail/export",
    params,
    "交易明细.xlsx",
  );
}

// 保存店铺看板指标设置
export function saveShopDashboardMetricSetting(params) {
  return axios.post("/v2/store/shop/dashboard/metric-setting/save", params);
}

// 保存店铺看板常用功能设置
export function saveShopDashboardOftenSetting(params) {
  return axios.post("/v2/store/shop/dashboard/often-setting/save", params);
}

// 创建店铺
export function addShop(params) {
  return axios.post("/v2/store/shop/info/create", params);
}

// 获取启用中的店铺类型列表
export function getEnabledShopTypeList() {
  return axios.get("/v2/store/shop/type/config/enabledList");
}

// 修改店铺
export function updateShop(params) {
  return axios.post("/v2/store/shop/info/update", params);
}

// 获取组织列表
export function getOrgCapabilities() {
  return axios.get("/v2/store/dept/capabilities");
}

export function getOrgList(params) {
  return axios.get("/v2/store/dept/list", params);
}

// 获取组织Tree
export function getOrgTree(params) {
  return axios.get("/v2/store/dept/tree", params);
}

// 获取组织详情
export function getOrgDetail(id) {
  return axios.get(`/v2/store/dept/${id}/show`);
}

// 新建组织
export function createOrg(params) {
  return axios.post("/v2/store/dept/create", params);
}

// 编辑组织
export function updateOrg(params) {
  return axios.post(`/v2/store/dept/${params.id}/update`, params);
}

// 删除组织
export function deleteOrg(ids) {
  return axios.post(`/v2/store/dept/${ids}/delete`);
}

// 启用/停用组织
export function switchOrg(id, params) {
  return axios.put(`/v2/store/dept/${id}/switch`, params);
}

// 获取角色列表
export function getRoleList(params) {
  return axios.get("/v2/store/shop/role/list", params);
}

// 获取角色详情
export function getRoleDetail(id) {
  return axios.get(`/v2/store/shop/role/${id}/show`);
}

// 创建角色
export function createRole(params) {
  return axios.post("/v2/store/shop/role/create", params);
}

// 修改角色
export function updateRole(id, params) {
  return axios.post(`/v2/store/shop/role/${id}/update`, params);
}

// 删除角色
export function deleteRole(ids) {
  return axios.post(`/v2/store/shop/role/${ids}/delete`);
}

// 导出角色
export function exportRole(params) {
  return downloadByPost("/v2/store/shop/role/export", params, "角色信息.xlsx");
}

// 获取店铺账号列表
export function getShopUserList(params) {
  return axios.get("/v2/store/shop/user/list", params);
}

// 获取店铺账号详情
export function getShopUserDetail(id) {
  return axios.get(`/v2/store/shop/user/${id}/show`);
}

// 创建店铺账号
export function createShopUser(params) {
  return axios.post("/v2/store/shop/user/create", params);
}

// 修改店铺账号
export function updateShopUser(id, params) {
  return axios.post(`/v2/store/shop/user/${id}/update`, params);
}

// 删除店铺账号
export function deleteShopUser(ids) {
  return axios.post(`/v2/store/shop/user/${ids}/delete`);
}

export function getAccountPermissionCapabilities() {
  return axios.get("/v2/store/shop/user/capabilities");
}

export function getAssignableRoles() {
  return axios.get("/v2/store/shop/role/assignable");
}

// 导出店铺账号
export function exportShopUser(params) {
  return downloadByPost("/v2/store/shop/user/export", params, "店铺账号.xlsx");
}

// 批量设置店铺账号脱敏权限
export function batchUpdateShopUserDesensitized(params) {
  return axios.post("/v2/store/shop/user/batch/desensitized", params);
}

// 批量导入店铺账号
export function importShopUser(params) {
  return axios.post("/v2/store/shop/user/import", params);
}

// 加载路由
export function getRouters(params) {
  return axios.get("/v2/store/menu/getRouters", params);
}

// 加载角色权限树（菜单 + 按钮）
export function getRolePermissionTree(params) {
  return axios.get("/v2/store/menu/permissionTree", params);
}

// 加载当前登录用户可分配的角色权限树（菜单 + 按钮）
export function getAssignableRolePermissionTree(params) {
  return axios.get("/v2/store/menu/assignablePermissionTree", params);
}

// 加载路由
export function getAdminRouters(params) {
  return axios.get("/v2/user/menu/getRouters", params);
}

// 查询素材分类
export function getOssCategorys(params) {
  return axios.get("/v2/resource/oss/category/getCategorys", params);
}

// 新建素材分类
export function addOssCategory(params) {
  return axios.post("/v2/resource/oss/category/create", params);
}

// 修改素材分类
export function updateOssCategory(params) {
  return axios.post("/v2/resource/oss/category/update", params);
}

// 删除素材分类
export function deleteOssCategory(id) {
  return axios.post(`/v2/resource/oss/category/${id}/delete`);
}

// 上传素材
export function uploadOss(formData) {
  return axios.filePost("/v2/resource/oss/upload", formData);
}

// 上传素材
export function uploadUserOss(formData) {
  return axios.filePost("/v2/resource/oss/userUpload", formData);
}

// 上传素材
export function uploadIdentifyOss(formData) {
  return axios.filePost("/v2/resource/oss/uploadWatermark", formData);
}

// 提交认证审核
export function submitIdentify(params) {
  return axios.post(`/v2/store/shop/identify/submit`, params);
}

// 查询最后一次认证审核
export function findIdentify() {
  return axios.get(`/v2/store/shop/identify/showLatest`);
}

// 查询素材列表
export function getSourceList(params) {
  return axios.get("/v2/resource/oss/list", params);
}

// 查询单个文件信息
export function findOssDetail(ossId) {
  return axios.get(`/v2/resource/oss/${ossId}/show`);
}

// 修改文件名称
export function updateOssName(params) {
  return axios.post("/v2/resource/oss/updateName", params);
}

// 移动素材分组
export function moveOssCategory(params) {
  return axios.post("/v2/resource/oss/move", params);
}

// 下载单个文件信息
export function downloadOss(ossId) {
  return axios.get(`/v2/resource/oss/download/${ossId}`);
}

// 获取素材临时下载链接
export function getOssDownloadLink(ossId) {
  return axios.post(`/v2/resource/oss/${ossId}/downloadLink`);
}

// 获取图片base64
export function getOssBase64(url) {
  return axios.get("/v2/resource/oss/getBase64", { url });
}

// 删除素材到回收站
export function deleteOss(ids) {
  return axios.post(`/v2/resource/oss/${ids}/delete`);
}

// 从回收站恢复素材
export function restoreOss(ids) {
  return axios.post(`/v2/resource/oss/${ids}/restore`);
}

// 从回收站彻底删除素材
export function deleteOssForever(ids) {
  return axios.post(`/v2/resource/oss/${ids}/deleteForever`);
}

// 初始化分片上传
export function initPart(params) {
  return axios.post("/v2/resource/oss/initPart", params);
}

// 上传分片
export function uploadPart(formData) {
  return axios.filePost("/v2/resource/oss/uploadPart", formData);
}

// 结束分片上传
export function completePart(params) {
  return axios.post("/v2/resource/oss/completePart", params);
}

// 获取腾讯云 COS 临时密钥
export function getTencentSts(params) {
  return axios.get("/v2/resource/oss/getTencentSts", params);
}

// 客户端上传后创建素材记录
export function createOssByClient(params) {
  return axios.post("/v2/resource/oss/createByClient", params);
}

// 结束分片上传
export function findOssSpace() {
  return axios.get("/v2/resource/oss/space");
}

// 结束分片上传
export function uploadVod(ossId) {
  return axios.post(`/v2/resource/oss/${ossId}/vod`);
}

// 远程链接文件存储
export function createOss(params) {
  return axios.post("/v2/resource/oss/create", params);
}

// 查询
export function findOssDownloadRecords(params) {
  return axios.get("/v2/resource/oss/record/list", params);
}

// 获取腾讯云上传签名
export function getTencentVodSign(params) {
  let pathparams = new URLSearchParams(params);
  return axios.post(`/v2/resource/oss/getTencentVodSign?${pathparams}`, params);
}

// 写回腾讯云上传结果
export function updateVodUploadResult(params) {
  return axios.post("/v2/resource/oss/updateVodUploadResult", params);
}

// 获取腾讯云播放签名
export function getTencentVodPsign(params) {
  let pathparams = new URLSearchParams(params);
  return axios.post(`/v2/resource/oss/getTencentVodPsign?${pathparams}`, params);
}

// 创建商品
export function createGoods(form) {
  return axios.post("/v2/store/goods/spu/create", form);
}

// 修改商品
export function updateGoods(id, form) {
  return axios.post(`/v2/store/goods/spu/goods/${id}/update`, form);
}

// 修改商品封面
export function updateGoodsImg(id, goodsImg) {
  return axios.post(`/v2/store/goods/spu/${id}/setGoodsImg`, {
    goodsImg: goodsImg,
  });
}

// 修改商品名称
export function updateGoodsName(id, goodsName) {
  return axios.post(`/v2/store/goods/spu/${id}/setGoodsName`, {
    updateMethod: 1,
    goodsName,
  });
}

// 修改课程总数
export function updateGoodsContentCount(id, contentCount) {
  return axios.post(`/v2/store/goods/spu/${id}/setContentCount`, {
    contentCount,
  });
}

// 删除商品
export function deleteGoods(ids) {
  return axios.post(`/v2/store/goods/spu/${ids}/delete`);
}

// 上下架商品
export function setStatusGoods(ids, status) {
  return axios.post(`/v2/store/goods/spu/${ids}/setStatus`, {
    saleStatus: status,
  });
}

// 商品上架设置
export function updateGoodsSaleSetting(ids, params) {
  return axios.post(`/v2/store/goods/spu/${ids}/setSaleSetting`, params);
}

// 商品评价
export function commentGoods(id, params) {
  return axios.post(`/v2/store/goods/spu/${id}/comment`, params);
}

// 评论列表
export function findCommentList(params) {
  return axios.get(`/v2/store/action/comment/list`, params);
}

// 查询通用分类
export function findStoCategorys(params) {
  return axios.get(`/v2/store/category/tree`, params);
}

// 创建商品分类
export function createGoodsCategory(form) {
  return axios.post("/v2/store/goods/category/create", form);
}

// 查询商品分类
export function findGoodsCategorys() {
  return axios.get("/v2/store/goods/category/tree");
}

// 查询商品分类
export function findGoodsAll(params) {
  return axios.get("/v2/store/goods/category/all", params);
}

// 修改商品分类
export function updateGoodsCategorys(id, params) {
  return axios.post(`/v2/store/goods/category/${id}/update`, params);
}

// 创建商品分组
export function createGoodsGroup(form) {
  return axios.post("/v2/store/goods/group/create", form);
}

// 查询商品分组列表（分页）
export function findGoodsGroupList(params) {
  return axios.get("/v2/store/goods/group/list", params);
}

// 查询商品分组详情
export function findGoodsGroupDetail(id) {
  return axios.get(`/v2/store/goods/group/${id}/show`);
}

// 查询商品分组选项（不分页）
export function findGoodsGroupAll(params) {
  return axios.get("/v2/store/goods/group/all", params);
}

// 查询商品分组（兼容旧调用）
export function findGoodsGroups(params) {
  return axios.get("/v2/store/goods/group/list", params);
}

// 修改商品分组
export function updateGoodsGroups(id, params) {
  return axios.post(`/v2/store/goods/group/${id}/update`, params);
}

// 创建优惠券分组
export function createCouponGroup(params) {
  return axios.post("/v2/store/coupon/group/create", params);
}

// 查询优惠券分组选项
export function findCouponGroupAll(params) {
  return axios.get("/v2/store/coupon/group/all", params);
}

// 删除优惠券分组
export function deleteCouponGroup(ids) {
  return axios.post(`/v2/store/coupon/group/${ids}/delete`);
}

// 批量更新优惠券分组
export function batchUpdateCouponGroup(params) {
  return axios.post("/v2/store/coupon/group/batch-update", params);
}

// 查询优惠券概览
export function findCouponOverview(params) {
  return axios.get("/v2/store/coupon/manage/overview", params);
}

// 查询优惠券列表
export function findCouponList(params) {
  return axios.get("/v2/store/coupon/manage/list", params);
}

// 查询优惠券详情
export function findCouponDetail(id) {
  return axios.get(`/v2/store/coupon/${id}/detail`);
}

// 保存优惠券
export function createCoupon(params) {
  return axios.post("/v2/store/coupon/create", params);
}

// 停止优惠券
export function stopCoupon(id) {
  return axios.post(`/v2/store/coupon/${id}/stop`);
}

// 切换公开搜索状态
export function updateCouponPublicSearch(id, enabled) {
  return axios.post(`/v2/store/coupon/${id}/public-search?enabled=${enabled}`);
}

// 删除优惠券
export function deleteCoupon(ids) {
  return axios.post(`/v2/store/coupon/${ids}/delete`);
}

// 删除商品分组（支持单个/批量，ids: "1" 或 "1,2,3"）
export function deleteGoodsGroups(ids) {
  return axios.post(`/v2/store/goods/group/${ids}/delete`);
}

// 批量修改商品分组排序
export function batchSortGoodsGroups(params) {
  return axios.post(`/v2/store/goods/group/batch-sort`, params);
}

// 查询品牌列表
export function findBrandList(params) {
  return axios.get("/v2/store/goods/brand/list", params);
}

// 查询品牌列表
export function findBrandOptions(params) {
  return axios.get("/v2/store/goods/brand/all", params);
}

// 创建品牌
export function createBrand(params) {
  return axios.post("/v2/store/goods/brand/create", params);
}

// 修改品牌
export function updateBrand(id, params) {
  return axios.post(`/v2/store/goods/brand/${id}/update`, params);
}

// 删除品牌
export function deleteBrand(id) {
  return axios.post(`/v2/store/goods/brand/${id}/delete`);
}

// 查询供应商列表
export function findSupplierList(params) {
  return axios.get("/v2/store/goods/supplier/list", params);
}

// 查询供应商列表
export function findSupplierOptions(params) {
  return axios.get("/v2/store/goods/supplier/all", params);
}

// 查询供应商
export function findSupplierDetail(id) {
  return axios.get(`/v2/store/goods/supplier/${id}/show`);
}

// 创建品牌
export function createSupplier(params) {
  return axios.post("/v2/store/goods/supplier/create", params);
}

// 修改品牌
export function updateSupplier(id, params) {
  return axios.post(`/v2/store/goods/supplier/${id}/update`, params);
}

// 删除品牌
export function deleteSupplier(id) {
  return axios.post(`/v2/store/goods/supplier/${id}/delete`);
}

// 查询秒杀活动列表
export function findSeckillActivityList(params) {
  return axios.get("/v2/store/seckill/activity/list", params);
}

// 查询限时折扣活动列表
export function findLimitedDiscountList(params) {
  return axios.get("/v2/store/limited/discount/list", params);
}

// 查询限时折扣活动详情
export function findLimitedDiscountDetail(id) {
  return axios.get(`/v2/store/limited/discount/${id}/show`);
}

// 查询拼团活动列表
export function findGroupbuyActivityList(params) {
  return axios.get("/v2/store/groupbuy/activity/list", params);
}

// 查询拼团活动详情
export function findGroupbuyActivityDetail(id) {
  return axios.get(`/v2/store/groupbuy/activity/${id}/show`);
}

// 创建拼团活动
export function createGroupbuyActivity(params) {
  return axios.post("/v2/store/groupbuy/activity/create", params);
}

// 更新拼团活动
export function updateGroupbuyActivity(id, params) {
  return axios.post(`/v2/store/groupbuy/activity/${id}/update`, params);
}

// 失效拼团活动
export function invalidGroupbuyActivity(id) {
  return axios.post(`/v2/store/groupbuy/activity/${id}/invalid`);
}

// 删除拼团活动
export function deleteGroupbuyActivity(ids) {
  return axios.post(`/v2/store/groupbuy/activity/${ids}/delete`);
}

// 创建限时折扣活动
export function createLimitedDiscount(params) {
  return axios.post("/v2/store/limited/discount/create", params);
}

// 更新限时折扣活动
export function updateLimitedDiscount(id, params) {
  return axios.post(`/v2/store/limited/discount/${id}/update`, params);
}

// 立即结束限时折扣活动
export function endLimitedDiscount(id) {
  return axios.post(`/v2/store/limited/discount/${id}/end`);
}

// 删除限时折扣活动
export function deleteLimitedDiscount(ids) {
  return axios.post(`/v2/store/limited/discount/${ids}/delete`);
}

// 查询秒杀活动详情
export function findSeckillActivityDetail(id) {
  return axios.get(`/v2/store/seckill/activity/${id}/show`);
}

// 创建秒杀活动
export function createSeckillActivity(params) {
  return axios.post("/v2/store/seckill/activity/create", params);
}

// 更新秒杀活动
export function updateSeckillActivity(id, params) {
  return axios.post(`/v2/store/seckill/activity/${id}/update`, params);
}

// 立即结束秒杀活动
export function endSeckillActivity(id) {
  return axios.post(`/v2/store/seckill/activity/${id}/end`);
}

// 删除秒杀活动
export function deleteSeckillActivity(ids) {
  return axios.post(`/v2/store/seckill/activity/${ids}/delete`);
}

// 查询商品详情
export function findGoodsDetail(id) {
  return axios.get(`/v2/store/goods/spu/${id}/show`);
}

// 修改商品SKU
export function updateGoodsSku(params) {
  return axios.put(`/v2/store/goods/sku`, params);
}

// 修改商品价格
export function updateGoodsSpuPrice(id, params) {
  return axios.post(`/v2/store/goods/spu/${id}/setPrice`, params);
}

// 创建直播行为日志
export function createLiveEventLog(params) {
  return axios.post(`/v2/store/live/event/log/create`, params);
}

// 查询直播行为日志列表
export function findLiveEventLogList(params) {
  return axios.get(`/v2/store/live/event/log/list`, params);
}

// 查询直播消息历史
export function findLiveMessageHistory(params) {
  return axios.get(`/v2/store/live/event/log/message/history`, params);
}

// 查询直播数据看板
export function findLiveEventDashboard(params) {
  return axios.get(`/v2/store/live/event/log/dashboard`, params);
}

// 查询直播成员统计
export function findLiveMemberSummary(params) {
  return axios.get(`/v2/store/live/member/summary`, params);
}

// 查询直播在线态调试数据
export function findLiveOnlineDebug(params) {
  return axios.get(`/v2/store/live/member/debug/online`, params);
}

// 查询当前直播置顶消息
export function findLiveTopMessageDetail(params) {
  return axios.get(`/v2/store/live/top/detail`, params);
}

// 查询当前进行中的直播签到
export function findCurrentLiveCheckin(params) {
  return axios.get(`/v2/store/live/checkin/current`, params);
}

// 查询直播签到列表
export function findLiveCheckinList(params) {
  return axios.get(`/v2/store/live/checkin/list`, params);
}

// 查询直播签到详情
export function findLiveCheckinDetail(id) {
  return axios.get(`/v2/store/live/checkin/${id}/show`);
}

// 创建直播签到
export function createLiveCheckin(params) {
  return axios.post(`/v2/store/live/checkin/create`, params);
}

// 结束直播签到
export function finishLiveCheckin(id) {
  return axios.post(`/v2/store/live/checkin/${id}/finish`);
}

// 查询直播签到记录列表
export function findLiveCheckinRecordList(params) {
  return axios.get(`/v2/store/live/checkin/record/list`, params);
}

// 保存当前直播置顶消息
export function saveLiveTopMessage(params) {
  return axios.post(`/v2/store/live/top/save`, params);
}

// 取消当前直播置顶消息
export function cancelLiveTopMessage(spuId) {
  return axios.post(`/v2/store/live/${spuId}/top/cancel`);
}

// 查询直播成员列表
export function findLiveMemberList(params) {
  return axios.get(`/v2/store/live/member/list`, params);
}

// 查询直播场次列表
export function findLiveSessionList(params) {
  return axios.get(`/v2/store/live/session/list`, params);
}

// 查询直播监控汇总
export function findLiveSessionMonitor(params) {
  return axios.get(`/v2/store/live/session/monitor`, params);
}

// 查询直播观众明细列表
export function findLiveAudienceDetailList(params) {
  return axios.get(`/v2/store/live/audience/detail/list`, params);
}

// 导出直播观众明细
export function exportLiveAudienceDetail(params) {
  return downloadByPost(
    "/v2/store/live/audience/detail/export",
    params,
    "观众明细.xlsx",
  );
}

// 切换直播成员限制状态
export function changeLiveMemberRestrict(params) {
  return axios.post(`/v2/store/live/member/restrict`, params);
}

// 查询直播带货商品列表
export function findLiveGoodsList(params) {
  return axios.get(`/v2/store/live/goods/list`, params);
}

// 查询直播带货明细列表
export function findLiveGoodsDetailList(params) {
  return axios.get(`/v2/store/live/goods/detail/list`, params);
}

// 导出直播带货明细
export function exportLiveGoodsDetail(params) {
  return downloadByPost(
    "/v2/store/live/goods/detail/export",
    params,
    "带货明细.xlsx",
  );
}

// 重建直播带货明细快照
export function rebuildLiveGoodsDetailSnapshot(params) {
  return axios.post(`/v2/store/live/goods/detail/snapshot/rebuild`, params);
}

// 查询直播员工数据列表
export function findLiveEmployeeDetailList(params) {
  return axios.get(`/v2/store/live/employee/detail/list`, params);
}

// 导出直播员工数据
export function exportLiveEmployeeDetail(params) {
  return downloadByPost(
    "/v2/store/live/employee/detail/export",
    params,
    "员工数据.xlsx",
  );
}

// 查询直播评论审核列表
export function findLiveCommentAuditList(params) {
  return axios.get(`/v2/store/live/comment/audit/list`, params);
}

// 导出直播评论审核列表
export function exportLiveCommentAudit(params) {
  return downloadByPost(
    "/v2/store/live/comment/audit/export",
    params,
    "直播评论列表.xlsx",
  );
}

// 审核通过直播评论
export function approveLiveCommentAudit(id, params) {
  return axios.post(`/v2/store/live/comment/audit/${id}/approve`, params || {});
}

// 隐藏直播评论
export function hideLiveCommentAudit(id, params) {
  return axios.post(`/v2/store/live/comment/audit/${id}/hide`, params || {});
}

// 恢复直播评论显示
export function restoreLiveCommentAudit(id, params) {
  return axios.post(`/v2/store/live/comment/audit/${id}/restore`, params || {});
}

// 批量审核通过直播评论
export function batchApproveLiveCommentAudit(params) {
  return axios.post(`/v2/store/live/comment/audit/batch-approve`, params);
}

// 查询直播优惠券列表
export function findLiveCouponList(params) {
  return axios.get(`/v2/store/live/coupon/list`, params);
}

// 绑定直播优惠券
export function bindLiveCoupon(params) {
  return axios.post(`/v2/store/live/coupon/bind`, params);
}

// 修改直播优惠券
export function updateLiveCoupon(id, params) {
  return axios.post(`/v2/store/live/coupon/${id}/update`, params);
}

// 发送直播优惠券
export function sendLiveCoupon(id, params) {
  return axios.post(`/v2/store/live/coupon/${id}/send`, params);
}

// 移除直播优惠券
export function removeLiveCoupon(id) {
  return axios.post(`/v2/store/live/coupon/${id}/remove`);
}

// 查询直播优惠券发送记录
export function findLiveCouponSendLogList(params) {
  return axios.get(`/v2/store/live/coupon/send-log/list`, params);
}

// 查询直播推荐卡片列表
export function findLiveRecommendCardList(params) {
  return axios.get(`/v2/store/live/recommend-card/list`, params);
}

// 创建直播推荐卡片
export function createLiveRecommendCard(params) {
  return axios.post(`/v2/store/live/recommend-card/create`, params);
}

// 更新直播推荐卡片
export function updateLiveRecommendCard(id, params) {
  return axios.post(`/v2/store/live/recommend-card/${id}/update`, params);
}

// 发送直播推荐卡片
export function sendLiveRecommendCard(id, params) {
  return axios.post(`/v2/store/live/recommend-card/${id}/send`, params);
}

// 查询直播推荐卡片发送记录
export function findLiveRecommendCardSendLogList(params) {
  return axios.get(`/v2/store/live/recommend-card/send-log/list`, params);
}

// 查询直播预告候选列表
export function findLiveAppointAvailableList(params) {
  return axios.get(`/v2/store/live/appoint/available-list`, params);
}

// 查询当前直播预告列表
export function findLiveAppointList(params) {
  return axios.get(`/v2/store/live/appoint/list`, params);
}

// 查询可用于直播的问卷列表
export function findLiveQuestionnaireAvailableList(params) {
  return axios.get(`/v2/store/live/questionnaire/available-list`, params);
}

// 批量绑定直播预告
export function bindLiveAppoint(params) {
  return axios.post(`/v2/store/live/appoint/bind`, params);
}

// 移除直播预告
export function removeLiveAppoint(id) {
  return axios.post(`/v2/store/live/appoint/${id}/remove`);
}

// 发送直播预告
export function sendLiveAppoint(params) {
  return axios.post(`/v2/store/live/appoint/send`, params);
}

// 查询直播预告发送记录
export function findLiveAppointSendLogList(params) {
  return axios.get(`/v2/store/live/appoint/send-log/list`, params);
}

// 查询直播预告预约记录
export function findLiveAppointRecordList(params) {
  return axios.get(`/v2/store/live/appoint/record/list`, params);
}

// 查询互动投票模板列表
export function findInteractionVoteList(params) {
  return axios.get(`/v2/store/interaction/vote/list`, params);
}

// 查询互动投票模板详情
export function findInteractionVoteDetail(id) {
  return axios.get(`/v2/store/interaction/vote/${id}/show`);
}

// 创建互动投票模板
export function createInteractionVote(params) {
  return axios.post(`/v2/store/interaction/vote/create`, params);
}

// 更新互动投票模板
export function updateInteractionVote(id, params) {
  return axios.post(`/v2/store/interaction/vote/${id}/update`, params);
}

// 复制互动投票模板
export function copyInteractionVote(id) {
  return axios.post(`/v2/store/interaction/vote/${id}/copy`);
}

// 删除互动投票模板
export function deleteInteractionVote(ids) {
  return axios.post(`/v2/store/interaction/vote/${ids}/delete`);
}

// 查询互动投票模板结果
export function findInteractionVoteResult(id) {
  return axios.get(`/v2/store/interaction/vote/${id}/result`);
}

// 查询直播投票候选模板
export function findLiveVoteAvailableList(params) {
  return axios.get(`/v2/store/live/vote/available-list`, params);
}

// 查询当前直播投票列表
export function findLiveVoteList(params) {
  return axios.get(`/v2/store/live/vote/bind-list`, params);
}

// 绑定直播投票
export function bindLiveVote(params) {
  return axios.post(`/v2/store/live/vote/bind`, params);
}

// 发起直播投票
export function startLiveVote(id, params) {
  return axios.post(`/v2/store/live/vote/${id}/start`, params);
}

// 结束直播投票
export function finishLiveVote(id, params) {
  return axios.post(`/v2/store/live/vote/${id}/finish`, params);
}

// 重发直播投票
export function repushLiveVote(id, params) {
  return axios.post(`/v2/store/live/vote/${id}/repush`, params);
}

// 继续收集直播投票
export function resumeLiveVote(id, params) {
  return axios.post(`/v2/store/live/vote/${id}/resume`, params);
}

// 查询直播投票结果
export function findLiveVoteResult(id) {
  return axios.get(`/v2/store/live/vote/${id}/result`);
}

// 查询直播投票操作日志
export function findLiveVoteLogList(params) {
  return axios.get(`/v2/store/live/vote/log/list`, params);
}

// 查询互动抽奖模板列表
export function findInteractionLotteryList(params) {
  return axios.get(`/v2/store/interaction/lottery/list`, params);
}

// 查询互动抽奖模板详情
export function findInteractionLotteryDetail(id) {
  return axios.get(`/v2/store/interaction/lottery/${id}/show`);
}

// 创建互动抽奖模板
export function createInteractionLottery(params) {
  return axios.post(`/v2/store/interaction/lottery/create`, params);
}

// 更新互动抽奖模板
export function updateInteractionLottery(id, params) {
  return axios.post(`/v2/store/interaction/lottery/${id}/update`, params);
}

// 复制互动抽奖模板
export function copyInteractionLottery(id) {
  return axios.post(`/v2/store/interaction/lottery/${id}/copy`);
}

// 查询直播抽奖候选模板
export function findLiveLotteryAvailableList(params) {
  return axios.get(`/v2/store/live/lottery/available-list`, params);
}

// 查询当前直播抽奖列表
export function findLiveLotteryList(params) {
  return axios.get(`/v2/store/live/lottery/bind-list`, params);
}

// 绑定直播抽奖
export function bindLiveLottery(params) {
  return axios.post(`/v2/store/live/lottery/bind`, params);
}

// 发起直播抽奖
export function startLiveLottery(id, params) {
  return axios.post(`/v2/store/live/lottery/${id}/start`, params);
}

// 开奖
export function drawLiveLottery(roundId, params) {
  return axios.post(`/v2/store/live/lottery/round/${roundId}/draw`, params);
}

// 隐藏直播抽奖
export function hideLiveLottery(id, params) {
  return axios.post(`/v2/store/live/lottery/${id}/hide`, params);
}

// 显示直播抽奖
export function showLiveLottery(id, params) {
  return axios.post(`/v2/store/live/lottery/${id}/show`, params);
}

// 移除直播抽奖
export function removeLiveLottery(id, params) {
  return axios.post(`/v2/store/live/lottery/${id}/remove`, params);
}

// 查询抽奖轮次详情
export function findLiveLotteryRoundDetail(roundId) {
  return axios.get(`/v2/store/live/lottery/round/${roundId}/detail`);
}

// 查询抽奖中奖名单
export function findLiveLotteryWinnerList(roundId, params) {
  return axios.get(`/v2/store/live/lottery/round/${roundId}/winner/list`, params);
}

// 批量绑定直播带货商品
export function bindLiveGoods(params) {
  return axios.post(`/v2/store/live/goods/bind`, params);
}

// 创建直播带货商品
export function createLiveGoods(params) {
  return axios.post(`/v2/store/live/goods/create`, params);
}

// 修改直播带货商品
export function updateLiveGoods(id, params) {
  return axios.post(`/v2/store/live/goods/${id}/update`, params);
}

// 删除直播带货商品
export function deleteLiveGoods(ids) {
  return axios.post(`/v2/store/live/goods/${ids}/delete`);
}

// 查询直播带货商品分组列表
export function findLiveGoodsGroupList(params) {
  return axios.get(`/v2/store/live/goods/group/list`, params);
}

// 创建直播带货商品分组
export function createLiveGoodsGroup(params) {
  return axios.post(`/v2/store/live/goods/group/create`, params);
}

// 修改直播带货商品分组
export function updateLiveGoodsGroup(id, params) {
  return axios.post(`/v2/store/live/goods/group/${id}/update`, params);
}

// 删除直播带货商品分组
export function deleteLiveGoodsGroup(ids) {
  return axios.post(`/v2/store/live/goods/group/${ids}/delete`);
}

// 查询直播带货商品分组关系列表
export function findLiveGoodsGroupRelList(params) {
  return axios.get(`/v2/store/live/goods/group/rel/list`, params);
}

// 创建直播带货商品分组关系
export function createLiveGoodsGroupRel(params) {
  return axios.post(`/v2/store/live/goods/group/rel/create`, params);
}

// 删除直播带货商品分组关系
export function deleteLiveGoodsGroupRel(ids) {
  return axios.post(`/v2/store/live/goods/group/rel/${ids}/delete`);
}

// 查询直播带货商品标签分类列表
export function findLiveGoodsTagCategoryList(params) {
  return axios.get(`/v2/store/live/goods/tag/category/list`, params);
}

// 查询直播带货商品标签列表
export function findLiveGoodsTagList(params) {
  return axios.get(`/v2/store/live/goods/tag/list`, params);
}

// 创建直播带货商品标签
export function createLiveGoodsTag(params) {
  return axios.post(`/v2/store/live/goods/tag/create`, params);
}

// 删除直播带货商品标签
export function deleteLiveGoodsTag(ids) {
  return axios.post(`/v2/store/live/goods/tag/${ids}/delete`);
}

// 查询直播带货商品标签关系列表
export function findLiveGoodsTagRelList(params) {
  return axios.get(`/v2/store/live/goods/tag/rel/list`, params);
}

// 删除直播带货商品标签关系
export function deleteLiveGoodsTagRel(ids) {
  return axios.post(`/v2/store/live/goods/tag/rel/${ids}/delete`);
}

// 单商品全量保存直播带货商品标签
export function replaceLiveGoodsTagRels(params) {
  return axios.post(`/v2/store/live/goods/tag/rel/replace`, params);
}

// 批量追加直播带货商品标签
export function batchAppendLiveGoodsTagRels(params) {
  return axios.post(`/v2/store/live/goods/tag/rel/batch-append`, params);
}

// 创建课程
export function createCourse(form) {
  return axios.post("/v2/store/goods/spu/create", form);
}

// 修改课程
export function updateCourse(id, form) {
  return axios.post(`/v2/store/goods/spu/${id}/update`, form);
}

// 更新课程配置
export function updateCourseConfigs(id, configs) {
  return axios.post(`/v2/store/goods/spu/${id}/setConfigs`, {
    id,
    configs,
  });
}

// 重置直播口令
export function resetCourseLivePassword(id) {
  return axios.post(`/v2/store/goods/spu/${id}/resetLivePassword`);
}

// 结束直播
export function endCourseLive(id) {
  return axios.post(`/v2/store/goods/spu/${id}/endLive`);
}

// 查询直播回放视频列表
export function findCoursePlaybackList(id) {
  return axios.get(`/v2/store/goods/spu/${id}/playback/list`);
}

// 手动重试直播回放转码
export function retryCoursePlaybackVod(id, ossId) {
  return axios.post(`/v2/store/goods/spu/${id}/playback/${ossId}/retryVod`);
}

// 课程目录
export function findCourseContents(id) {
  return axios.get(`/v2/store/goods/spu/course/${id}/contents`);
}

// 按所属训练营目录导入营期目录
export function importTrainingCampContents(id) {
  return axios.post(`/v2/store/goods/spu/course/${id}/importTrainingCampContents`);
}

// 创建课程内容
export function createCourseContent(params) {
  return axios.post(`/v2/store/goods/spu/content/create`, params);
}

// 查询课程
export function findCourseList(params) {
  return axios.get("/v2/store/goods/spu/list", params);
}

export function findCourseAllList(params) {
  return axios.get("/v2/store/goods/spu/all", params);
}

// 查询训练营列表
export function findTrainingCampList(params) {
  return axios.get("/v2/store/training/camp/list", params);
}

// 查询训练营详情聚合
export function findTrainingCampDetail(id) {
  return axios.get(`/v2/store/training/camp/${id}/detail`);
}

// 按商品查询训练营配置
export function findTrainingCampBySpuId(spuId) {
  return axios.get(`/v2/store/training/camp/spu/${spuId}/show`);
}

// 按商品保存训练营配置
export function saveTrainingCampBySpuId(spuId, params) {
  return axios.post(`/v2/store/training/camp/spu/${spuId}/save`, params);
}

// 查询训练营任务列表
export function findTrainingCampTaskList(params) {
  return axios.get("/v2/store/training/camp/task/list", params);
}

// 查询训练营任务详情
export function findTrainingCampTaskDetail(id) {
  return axios.get(`/v2/store/training/camp/task/${id}/show`);
}

// 创建训练营任务
export function createTrainingCampTask(params) {
  return axios.post("/v2/store/training/camp/task/create", params);
}

// 修改训练营任务
export function updateTrainingCampTask(id, params) {
  return axios.post(`/v2/store/training/camp/task/${id}/update`, params);
}

// 删除训练营任务
export function deleteTrainingCampTask(ids) {
  return axios.post(`/v2/store/training/camp/task/${ids}/delete`);
}

// 查询训练营营员列表
export function findTrainingCampMemberList(params) {
  return axios.get("/v2/store/member/subscribe/list", params);
}

// 创建训练营营员
export function createTrainingCampMember(params) {
  return axios.post("/v2/store/member/subscribe/training/camp/create", params);
}

// 修改训练营营员
export function updateTrainingCampMember(id, params) {
  return axios.post(`/v2/store/member/subscribe/training/camp/${id}/update`, params);
}

// 删除训练营营员
export function deleteTrainingCampMember(ids) {
  return axios.post(`/v2/store/member/subscribe/training/camp/${ids}/delete`);
}

// 查询课程详情
export function findCourseDetail(id) {
  return axios.get(`/v2/store/goods/spu/${id}/show`);
}

// 查询直播所属课程列表
export function findLiveBelongCourses(id) {
  return axios.get(`/v2/store/goods/spu/live/${id}/belongs`);
}

// 查询直播分享信息
export function findCourseShareInfo(id, params) {
  return axios.get(`/v2/store/goods/spu/${id}/shareInfo`, params);
}

// 保存直播分享语
export function saveCourseShareInfo(id, params) {
  return axios.post(`/v2/store/goods/spu/${id}/shareInfo`, params);
}

// 创建讲师
export function createTeacher(form) {
  return axios.post("/v2/store/teacher/create", form);
}

// 通过手机号快捷创建讲师
export function quickCreateTeacherByMobile(mobile) {
  return axios.post("/v2/store/teacher/quickCreate", { mobile });
}

// 查询直播课程角色列表
export function findLiveRoleListBySpuId(spuId) {
  return axios.get(`/v2/store/liveRole/spu/${spuId}/list`);
}

// 创建直播课程角色
export function createLiveRole(form) {
  return axios.post("/v2/store/liveRole/create", form);
}

// 修改直播课程角色
export function updateLiveRole(id, form) {
  return axios.post(`/v2/store/liveRole/${id}/update`, form);
}

// 替换直播课程角色列表
export function replaceLiveRoleList(spuId, list) {
  return axios.post(`/v2/store/liveRole/spu/${spuId}/replace`, list);
}

// 删除直播课程角色
export function deleteLiveRole(ids) {
  return axios.post(`/v2/store/liveRole/${ids}/delete`);
}

// 查询讲师详情
export function findTeacherDetail(id) {
  return axios.get(`/v2/store/teacher/${id}/show`);
}

// 修改讲师
export function updateTeacher(id, form) {
  return axios.post(`/v2/store/teacher/${id}/update`, form);
}

// 删除讲师（支持单个/批量，ids: "1" or "1,2,3"）
export function deleteTeacher(ids) {
  return axios.post(`/v2/store/teacher/${ids}/delete`);
}

// 创建打卡
export function createPunch(form) {
  return axios.post("/v2/store/punch/create", form);
}

// 查询打卡
export function findPunchList(form) {
  return axios.get("/v2/store/punch/list", form);
}

// 查询打卡详情
export function findPunchDetail(id) {
  return axios.get(`/v2/store/punch/${id}/show`);
}

// 查询打卡学员
export function findPunchUserList(params) {
  return axios.get("/v2/store/punch/user/list", params);
}

// 查询打卡分组
export function findPunchGroupList(params) {
  return axios.get("/v2/store/punch/group/list", params);
}

// 创建打卡分组
export function createPunchGroup(form) {
  return axios.post("/v2/store/punch/group/create", form);
}

// 查询打卡助教
export function findPunchTeacherList(params) {
  return axios.get("/v2/store/punch/teacher/list", params);
}

// 添加打卡助教
export function createPunchTeacher(form) {
  return axios.post("/v2/store/punch/teacher/createBatch", form);
}

// 创建打卡任务
export function createPunchTask(form) {
  return axios.post("/v2/store/punch/task/createBatch", form);
}

// 查询打卡任务
export function findPunchTaskList(params) {
  return axios.get("/v2/store/punch/task/list", params);
}

// 查询通用分类
export function findCategoryTree(params) {
  return axios.get("/v2/store/category/tree", params);
}

// 创建通用分类
export function createCategory(form) {
  return axios.post("/v2/store/category/create", form);
}

// 修改通用分类
export function updateCategory(id, form) {
  return axios.post(`/v2/store/category/${id}/update`, form);
}

// 删除通用分类
export function deleteCategory(id) {
  return axios.post(`/v2/store/category/${id}/delete`);
}

// 查询讲师
export function findTeacherList(form) {
  return axios.get("/v2/store/teacher/list", form);
}

// 创建页面
export function createPage(form) {
  return axios.post("/v2/store/shop/page/create", form);
}

// 修改页面
export function updatePage(id, params) {
  return axios.post(`/v2/store/shop/page/${id}/update`, params);
}

// 查询页面
export function findPageList(params) {
  return axios.get("/v2/store/shop/page/list", params);
}

// 查询页面详情
export function findPageDetail(id) {
  return axios.get(`/v2/store/shop/page/${id}/show`);
}

// 创建标签
export function createTag(form) {
  return axios.post("/v2/store/shop/tag/create", form);
}

// 查询标签
export function findTagList(params) {
  return axios.get("/v2/store/shop/tag/list", params);
}

// 查询标签
export function findAllTags(params) {
  return axios.get("/v2/store/shop/tag/all", params);
}

// 查询标签详情
export function findTagDetail(id) {
  return axios.get(`/v2/store/shop/tag/${id}/show`);
}

// 删除标签
export function deleteTag(id) {
  return axios.post(`/v2/store/shop/tag/${id}/delete`);
}

// 修改标签
export function updateTag(id, params) {
  return axios.post(`/v2/store/shop/tag/${id}/update`, params);
}

// 创建圈子标签
export function createCommunityTag(form) {
  return axios.post("/v2/store/community/tag/create", form);
}

// 查询圈子标签
export function findCommunityTagList(params) {
  return axios.get("/v2/store/community/tag/list", params);
}

// 查询圈子标签
export function findCommunityAllTag(params) {
  return axios.get("/v2/store/community/tag/all", params);
}

// 查询圈子标签详情
export function findCommunityTagDetail(id) {
  return axios.get(`/v2/store/community/tag/${id}/show`);
}

// 删除圈子标签
export function deleteCommunityTag(id) {
  return axios.post(`/v2/store/community/tag/${id}/delete`);
}

// 修改圈子标签
export function updateCommunityTag(id, params) {
  return axios.post(`/v2/store/community/tag/${id}/update`, params);
}

// 创建学习圈
export function createCommunity(form) {
  return axios.post("/v2/store/community/create", form);
}

// 查询学习圈
export function findCommunityList(params) {
  return axios.get("/v2/store/community/list", params);
}

// 查询学习圈
export function findMyAllCommunity(params) {
  return axios.get("/v2/store/community/myAllCommunitys", params);
}

// 查询学习圈详情
export function findCommunityDetail(id) {
  return axios.get(`/v2/store/community/${id}/show`);
}

// 修改学习圈封面
export function updateCommunityCover(id, cover) {
  return axios.post(`/v2/store/community/${id}/setCover`, {
    cover,
  });
}

// 修改学习圈名称
export function updateCommunityName(id, name) {
  return axios.post(`/v2/store/community/${id}/setName`, {
    name,
  });
}

// 修改学习圈售卖设置
export function updateCommunitySaleSetting(id, params) {
  return axios.post(`/v2/store/community/${id}/setSaleSetting`, params);
}

// 查询学习圈加入状态
export function checkCommunityMember(communityId) {
  return axios.get(`/v2/store/community/member/${communityId}/checkMember`);
}

// 加入免费学习圈
export function joinCommunityMember(communityId) {
  return axios.post(`/v2/store/community/member/${communityId}/join`);
}

// 创建学习圈动态
export function createCommunityDynamic(params) {
  return axios.post("/v2/store/community/dynamic/create", params);
}

// 主题合集关联
export function createCommunityDynamicCollection(id, params) {
  return axios.post(
    `/v2/store/community/dynamic/${id}/contactCollection`,
    params
  );
}

// 删除主题合集关联
export function deleteCommunityDynamicCollection(id, params) {
  return axios.post(
    `/v2/store/community/dynamic/${id}/deleteCollection`,
    params
  );
}

// 查询学习圈合集
export function findCommunityCollectionList(params) {
  return axios.get("/v2/store/community/collection/list", params);
}

// 创建学习圈合集
export function createCommunityCollection(params) {
  return axios.post("/v2/store/community/collection/create", params);
}

// 查询学习圈文件数
export function findCommunityFileCount(communityId) {
  return axios.get(`/v2/store/community/dynamic/${communityId}/findFileCount`);
}

// 查询学习圈动态
export function findCommunityDynamicList(params) {
  return axios.get("/v2/store/community/dynamic/list", params);
}

// 查询动态详情
export function findCommunityDynamicDetail(id) {
  return axios.get(`/v2/store/community/dynamic/${id}/show`);
}

// 删除动态
export function deleteCommunityDynamic(id) {
  return axios.post(`/v2/store/community/dynamic/${id}/delete`);
}

// 查询动态评论
export function findCommunityDynamicComments(id, params) {
  return axios.get(`/v2/store/community/dynamic/${id}/findComments`, params);
}

// 查询动态评论
export function findCommunityDynamicAllComments(id, params) {
  return axios.get(`/v2/store/community/dynamic/${id}/findAllComments`, params);
}

// 发送评论
export function sendComment(id, params) {
  return axios.post(`/v2/store/community/dynamic/${id}/comment`, params);
}

// 回复评论
export function replyComment(id, params) {
  return axios.post(`/v2/store/community/dynamic/${id}/reply`, params);
}

// 点赞
export function sendPraise(id, params) {
  return axios.post(`/v2/store/community/dynamic/${id}/praise`, params);
}

// 取消点赞
export function cancelPraise(id, params) {
  return axios.post(`/v2/store/community/dynamic/${id}/unpraise`, params);
}

// 查询圈子动态时间选项
export function findCommunityMonths(id) {
  return axios.get(`/v2/store/community/dynamic/${id}/months`);
}

// 查询顶部Label
export function findCommunityLabels(params) {
  return axios.get(`/v2/store/community/label/all`, params);
}

// 创建导航
export function createNav(form) {
  return axios.post("/v2/store/shop/nav/create", form);
}

// 查询导航下拉列表
export function findNavOptions(params) {
  return axios.get("/v2/store/shop/nav/options", params);
}

// 查询导航
export function findNavList(params) {
  return axios.get("/v2/store/shop/nav/list", params);
}

// 查询导航详情
export function findNavDetail(id) {
  return axios.get(`/v2/store/shop/nav/${id}/show`);
}

// 删除导航
export function deleteNav(id) {
  return axios.post(`/v2/store/shop/nav/${id}/delete`);
}

// 修改导航
export function updateNav(id, params) {
  return axios.post(`/v2/store/shop/nav/${id}/update`, params);
}

// 查询店铺装修风格配置
export function findDecorationStyleDetail() {
  return axios.get("/v2/store/shop/settings/decoration/style/detail");
}

// 保存店铺装修风格配置
export function saveDecorationStyle(params) {
  return axios.post("/v2/store/shop/settings/decoration/style/save", params);
}

// 查询店铺装修通用设置配置
export function findDecorationCommonSettingDetail() {
  return axios.get("/v2/store/shop/settings/decoration/common/detail");
}

// 保存店铺装修通用设置配置
export function saveDecorationCommonSetting(params) {
  return axios.post("/v2/store/shop/settings/decoration/common/save", params);
}

// 查询直播设置配置
export function findLiveSettingDetail() {
  return axios.get("/v2/store/shop/setting/live/detail");
}

// 保存直播设置配置
export function saveLiveSetting(params) {
  return axios.post("/v2/store/shop/setting/live/save", params);
}

// 查询版权保护配置
export function findCopyrightSettingDetail() {
  return axios.get("/v2/store/shop/setting/copyright/detail");
}

// 保存版权跑马灯配置
export function saveCopyrightMarqueeSetting(params) {
  return axios.post("/v2/store/shop/setting/copyright/marquee/save", params);
}

// 保存版权水印配置
export function saveCopyrightWatermarkSetting(params) {
  return axios.post("/v2/store/shop/setting/copyright/watermark/save", params);
}

// 查询中控快捷发送分组
export function findLiveQuickGroupList(params) {
  return axios.get("/v2/store/live/quick/group/list", params);
}

// 新增中控快捷发送分组
export function createLiveQuickGroup(params) {
  return axios.post("/v2/store/live/quick/group/create", params);
}

// 修改中控快捷发送分组
export function updateLiveQuickGroup(id, params) {
  return axios.post(`/v2/store/live/quick/group/${id}/update`, params);
}

// 删除中控快捷发送分组
export function deleteLiveQuickGroup(ids) {
  return axios.post(`/v2/store/live/quick/group/${ids}/delete`);
}

// 分页查询中控快捷发送消息
export function findLiveQuickMessageList(params) {
  return axios.get("/v2/store/live/quick/message/list", params);
}

// 查询全部中控快捷发送消息
export function findAllLiveQuickMessageList(params) {
  return axios.get("/v2/store/live/quick/message/all", params);
}

// 新增中控快捷发送消息
export function createLiveQuickMessage(params) {
  return axios.post("/v2/store/live/quick/message/create", params);
}

// 修改中控快捷发送消息
export function updateLiveQuickMessage(id, params) {
  return axios.post(`/v2/store/live/quick/message/${id}/update`, params);
}

// 删除中控快捷发送消息
export function deleteLiveQuickMessage(ids) {
  return axios.post(`/v2/store/live/quick/message/${ids}/delete`);
}

// 查询直播运营模板列表
export function findLiveOperationTemplateList(params) {
  return axios.get("/v2/store/live/operation/template/list", params);
}

// 新增直播运营模板
export function createLiveOperationTemplate(params) {
  return axios.post("/v2/store/live/operation/template/create", params);
}

// 修改直播运营模板
export function updateLiveOperationTemplate(id, params) {
  return axios.post(`/v2/store/live/operation/template/${id}/update`, params);
}

// 删除直播运营模板
export function deleteLiveOperationTemplate(ids) {
  return axios.post(`/v2/store/live/operation/template/${ids}/delete`);
}

// 查询直播运营模板消息列表
export function findLiveOperationTemplateTaskList(params) {
  return axios.get("/v2/store/live/operation/template/task/list", params);
}

// 新增直播运营模板消息
export function createLiveOperationTemplateTask(params) {
  return axios.post("/v2/store/live/operation/template/task/create", params);
}

// 修改直播运营模板消息
export function updateLiveOperationTemplateTask(id, params) {
  return axios.post(`/v2/store/live/operation/template/task/${id}/update`, params);
}

// 删除直播运营模板消息
export function deleteLiveOperationTemplateTask(ids) {
  return axios.post(`/v2/store/live/operation/template/task/${ids}/delete`);
}

// 应用直播运营模板到当前直播定时消息
export function applyLiveOperationTemplate(templateId, params) {
  return axios.post(
    `/v2/store/live/operation/template/task/${templateId}/apply`,
    params,
  );
}

// 查询订单列表
export function findOrderList(params) {
  return axios.get(`/v2/pay/order/list`, params);
}

// 查询课程订单列表
export function findCourseOrderList(params) {
  return axios.get(`/v2/trade/admin/course/order/list`, params);
}

// 查询课程订单详情
export function findCourseOrderDetail(orderNo) {
  return axios.get(`/v2/trade/admin/course/order/${orderNo}/show`);
}

// 主动退款课程订单
export function refundCourseOrder(orderNo, params) {
  return axios.post(`/v2/trade/admin/course/order/${orderNo}/refund`, params);
}

// 查询开关
export function findShopSwitchs(params) {
  return axios.get(`/v2/store/shop/console/switchs`, params);
}

// 查询开关列表
export function findShopSwitchList(params) {
  return axios.get(`/v2/store/shop/console/list`, params);
}

// 修改开关
export function updateShopSwitchs(params) {
  return axios.post(`/v2/store/shop/console/batchUpdate`, params);
}

// 查询appids
export function getSphToken(appId) {
  return axios.get(`/wechat/wxsph/api/${appId}/getToken`);
}

// 查询appids
export function getSphGoodsList(appId) {
  return axios.get(`/wechat/wxsph/api/${appId}/goodsList`);
}

// 查询appids
export function findAppidsList(params) {
  return axios.get(`/wechat/appid/list`, params);
}

// 查询微信小店列表
export function findWxstoreList() {
  return axios.get(`/v2/store/wechat/shop/list`);
}

// 保存微信小店草稿
export function saveWxstore(params) {
  return axios.post(`/v2/store/wechat/shop/save`, params);
}

// 测试微信小店配置并同步店铺信息
export function testWxstore(id) {
  return axios.post(`/v2/store/wechat/shop/${id}/test`);
}

// 查询微信小店详情
export function findWxstoreDetail(id) {
  return axios.get(`/v2/store/wechat/shop/${id}/detail`);
}

// 查询微信小店商品列表
export function findWxstoreGoodsList(id, params) {
  return axios.get(`/v2/store/wechat/shop/${id}/goods/list`, params);
}

// 同步微信小店商品
export function syncWxstoreGoods(id) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/sync`);
}

// 微信小店商品上下架
export function setWxstoreGoodsStatus(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/setStatus`, params);
}

// 同步单个微信小店商品
export function syncWxstoreOneGoods(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/syncOne`, params);
}

// 按商品ID拉取单个微信小店商品
export function pullWxstoreOneGoods(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/pullOne`, params);
}

// 微信小店商品修改价格
export function setWxstoreGoodsPrice(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/price/update`, params);
}

// 微信小店商品修改库存
export function setWxstoreGoodsStock(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/stock/update`, params);
}

// 微信小店商品绑定本地商品/课程
export function bindWxstoreGoodsRelation(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/goods/bind`, params);
}

// 查询微信小店赠品列表
export function findWxstoreGiftList(id, params) {
  return axios.get(`/v2/store/wechat/shop/${id}/gift/list`, params);
}

// 同步微信小店赠品
export function syncWxstoreGiftList(id) {
  return axios.post(`/v2/store/wechat/shop/${id}/gift/sync`);
}

// 同步单个微信小店赠品
export function syncWxstoreOneGift(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/gift/syncOne`, params);
}

// 按赠品ID拉取单个微信小店赠品
export function pullWxstoreOneGift(id, params) {
  return axios.post(`/v2/store/wechat/shop/${id}/gift/pullOne`, params);
}

// 查询微信小店类目列表
export function findWxstoreCategoryList(id) {
  return axios.get(`/v2/store/wechat/shop/${id}/category/list`);
}

// 同步微信小店类目
export function syncWxstoreCategory(id) {
  return axios.post(`/v2/store/wechat/shop/${id}/category/sync`);
}

// 创建appid
export function createAppids(params) {
  return axios.post(`/wechat/appid/create`, params);
}

// 同步渠道商品
export function findCityList(appId, params) {
  return axios.get(`/wechat/wxsph/api/${appId}/cityList`, params);
}

// 同步渠道商品
export function asyncChannelGoods(channelId) {
  return axios.post(`/v2/store/goods/channel/${channelId}/async`);
}

// 查询渠道商品列表
export function findChannelGoodsList(params) {
  return axios.get(`/v2/store/goods/channel/list`, params);
}

// 查询学员列表
export function findMemberList(params) {
  return axios.get(`/v2/store/member/list`, params);
}

// 查询客户列表顶部统计
export function findMemberCustomerStats() {
  return axios.get(`/v2/store/member/customer/stats`);
}

// 查询学员详情
export function findMemberDetail(id) {
  return axios.get(`/v2/store/member/${id}/show`);
}

// 查询学员学习数据详情
export function findMemberStudyDetail(id, params) {
  return axios.get(`/v2/store/member/${id}/study/show`, params);
}

// 查询学员课程进度
export function findMemberCourseProgressList(id, params) {
  return axios.get(`/v2/store/member/${id}/course/progress/list`, params);
}

// 更新学员信息
export function updateMember(id, params) {
  return axios.post(`/v2/store/member/${id}/update`, params);
}

// 查询当前用户视图配置
export function showUserViewSetting(params) {
  return axios.get(`/v2/store/view/setting/show`, params);
}

// 保存当前用户视图配置
export function saveUserViewSetting(params) {
  return axios.post(`/v2/store/view/setting/save`, params);
}

// 查询用户学习记录列表
export function findUserLearnRecordList(params) {
  return axios.get(`/v2/store/user/learn/record/list`, params);
}

// 查询信息采集提交记录列表
export function findInfoCollectRecordList(params) {
  return axios.get(`/v2/store/info/collect/record/list`, params);
}

// 查询信息采集提交记录详情
export function findInfoCollectRecordDetail(collectId, recordId) {
  return axios.get(`/v2/store/info/collect/${collectId}/data/records/${recordId}/show`);
}

// 修改评论
export function updateComment(params) {
  return axios.put(`/v2/store/action/comment`, params);
}

// 添加课程会员
export function importMember(params) {
  return axios.post(`/v2/store/member/subscribe/import`, params);
}

// 批量导入课程会员
export function importMemberBatch(params) {
  return axios.post(`/v2/store/member/subscribe/importBatch`, params);
}

// 下载课程会员导入模板
export function downloadMemberImportTemplate(params) {
  return downloadByPost(
    `/v2/store/member/subscribe/importTemplate`,
    params,
    "课程学员导入模板.xlsx"
  );
}

// 移除课程会员
export function removeMember(id) {
  return axios.post(`/v2/store/member/subscribe/${id}/delete`);
}

// 延期课程会员
export function delayMember(id, params) {
  return axios.post(`/v2/store/member/subscribe/${id}/delay`, params);
}

// 查询课程会员列表
export function findCourseMemberList(params) {
  return axios.get(`/v2/store/member/subscribe/list`, params);
}

// 推送日志
export function pushLog(params) {
  params.apptype = "web";
  params.host = window.location.host;
  return axios.post(`/v2/store/log/push`, params);
}

// 查询赛事活动列表
export function findCompetitionList(params) {
  return axios.get(`/v2/store/competition/list`, params);
}

// 查询赛事活动作品列表
export function findDrawList(params) {
  return axios.get(`/v2/store/draw/list`, params);
}

// 查询随机机器人列表
export function findRandomRobotList(params) {
  return axios.get(`/v2/user/info/randomRobots`, params);
}

// 查询直播定时消息配置
export function getLiveScheduledConfig(params) {
  return axios.get(`/v2/store/live/scheduled/config/detail`, params);
}

// 保存直播定时消息配置
export function saveLiveScheduledConfig(params) {
  return axios.post(`/v2/store/live/scheduled/config/save`, params);
}

// 查询直播定时消息任务列表
export function findLiveScheduledTaskList(params) {
  return axios.get(`/v2/store/live/scheduled/task/list`, params);
}

// 创建直播定时消息任务
export function createLiveScheduledTask(params) {
  return axios.post(`/v2/store/live/scheduled/task/create`, params);
}

// 删除直播定时消息任务
export function deleteLiveScheduledTask(id, params) {
  return axios.post(`/v2/store/live/scheduled/task/${id}/delete`, params);
}

// 立即发送直播定时消息任务
export function sendLiveScheduledTask(id, params) {
  return axios.post(`/v2/store/live/scheduled/task/${id}/send`, params);
}

// 查询直播机器人配置
export function getLiveRobotConfig(params) {
  return axios.get(`/v2/store/live/robot/config/detail`, params);
}

// 保存直播机器人配置
export function saveLiveRobotConfig(params) {
  return axios.post(`/v2/store/live/robot/config/save`, params);
}

// 查询直播机器人任务列表
export function findLiveRobotTaskList(params) {
  return axios.get(`/v2/store/live/robot/task/list`, params);
}

// 查询直播机器人任务统计
export function findLiveRobotTaskStat(params) {
  return axios.get(`/v2/store/live/robot/task/stat`, params);
}

// 批量添加直播机器人
export function addLiveRobotTask(params) {
  return axios.post(`/v2/store/live/robot/task/add`, params);
}

// 修改直播机器人时间
export function updateLiveRobotTaskTime(id, params) {
  return axios.post(`/v2/store/live/robot/task/${id}/update-time`, params);
}

// 删除直播机器人任务
export function deleteLiveRobotTask(id, params) {
  return axios.post(`/v2/store/live/robot/task/${id}/delete`, params);
}

// 批量删除直播机器人任务
export function batchDeleteLiveRobotTask(params) {
  return axios.post(`/v2/store/live/robot/task/batch-delete`, params);
}

// 手动触发机器人进场
export function manualEnterLiveRobotTask(id, params) {
  return axios.post(`/v2/store/live/robot/task/${id}/manual-enter`, params);
}

// 手动触发机器人离场
export function manualExitLiveRobotTask(id, params) {
  return axios.post(`/v2/store/live/robot/task/${id}/manual-exit`, params);
}

// 发布作品
export function createDraw(params) {
  return axios.post(`/v2/store/draw/create`, params);
}

// 刷新作品排行榜
export function refreshRank(params) {
  return axios.post(`/v2/store/draw/refreshRank`, params);
}

// 给作品投票
export function sendDrawVote(id, userId) {
  return axios.post(`/v2/store/draw/${id}/sendVote?userId=${userId}`);
}

// 创建短链接
export function createShortUrl(params) {
  return axios.post(`/v2/store/shorturl/create`, params);
}

// 创建临时短链接
export function createTempShortUrl(params) {
  return axios.post(`/v2/store/shorturl/createTemp`, params);
}

// 查询短链接
export function findShortUrl(key) {
  return axios.get(`/v2/store/shorturl/${key}/findByKey`);
}

// 查询素材分类
export function getWxworkGroups(params) {
  return axios.get("/v2/store/wxwork/group/getGroups", params);
}

// 新建素材分类
export function addWxworkGroup(params) {
  return axios.post("/v2/store/wxwork/group/create", params);
}

// 修改素材分类
export function updateWxworkGroup(params) {
  return axios.post("/v2/store/wxwork/group/update", params);
}

// 删除素材分类
export function deleteWxworkGroup(id) {
  return axios.post(`/v2/store/wxwork/group/${id}/delete`);
}

// 同步标签组
export function asyncTagGroup() {
  return axios.post("/v2/store/wxwork/taggroup/async");
}

// 新建标签组
export function addTagGroup(params) {
  return axios.post("/v2/store/wxwork/taggroup/create", params);
}

// 修改标签组
export function updateTagGroup(params) {
  return axios.post("/v2/store/wxwork/taggroup/update", params);
}

// 删除标签组
export function deleteTagGroup(id) {
  return axios.post(`/v2/store/wxwork/taggroup/${id}/delete`);
}

// 标签组列表
export function findTagGroupList(params) {
  return axios.get("/v2/store/wxwork/taggroup/list", params);
}

// 渠道活码列表
export function getChannelCodeList(params) {
  return axios.get("/v2/store/wxwork/channelcode/list", params);
}

// 查询渠道活码详情
export function getChannelCodeDetail(id) {
  return axios.get(`/v2/store/wxwork/channelcode/${id}/show`);
}

// 创建渠道活码
export function createChannelCode(params) {
  return axios.post("/v2/store/wxwork/channelcode/create", params);
}

// 更新渠道活码
export function updateChannelCode(id, params) {
  return axios.post(`/v2/store/wxwork/channelcode/${id}/update`, params);
}

// 删除渠道活码
export function deleteChannelCode(id) {
  return axios.post(`/v2/store/wxwork/channelcode/${id}/delete`);
}

// 标签组详情
export function findTagGroupDetail(id) {
  return axios.get(`/v2/store/wxwork/taggroup/${id}/show`);
}

export function getLbsCodeList(params) {
  return axios.get("/v2/store/wxwork/lbscode/list", params);
}

export function getLbsCodeDetail(id) {
  return axios.get(`/v2/store/wxwork/lbscode/${id}/show`);
}

export function createLbsCode(params) {
  return axios.post("/v2/store/wxwork/lbscode/create", params);
}

export function updateLbsCode(id, params) {
  return axios.post(`/v2/store/wxwork/lbscode/${id}/update`, params);
}

export function deleteLbsCode(id) {
  return axios.post(`/v2/store/wxwork/lbscode/${id}/delete`);
}

export function getLbsRuleList(params) {
  return axios.get("/v2/store/wxwork/lbsrule/list", params);
}

export function createLbsRule(params) {
  return axios.post("/v2/store/wxwork/lbsrule/create", params);
}

export function updateLbsRule(id, params) {
  return axios.post(`/v2/store/wxwork/lbsrule/${id}/update`, params);
}

export function deleteLbsRule(id) {
  return axios.post(`/v2/store/wxwork/lbsrule/${id}/delete`);
}

export function getLbsAddressList(params) {
  return axios.get("/v2/store/wxwork/lbsaddress/list", params);
}

export function getLbsAddressDetail(id) {
  return axios.get(`/v2/store/wxwork/lbsaddress/${id}/show`);
}

export function createLbsAddress(params) {
  return axios.post("/v2/store/wxwork/lbsaddress/create", params);
}

export function updateLbsAddress(id, params) {
  return axios.post(`/v2/store/wxwork/lbsaddress/${id}/update`, params);
}

export function deleteLbsAddress(id) {
  return axios.post(`/v2/store/wxwork/lbsaddress/${id}/delete`);
}

export function getLbsScanLogList(params) {
  return axios.get("/v2/store/wxwork/lbsscanlog/list", params);
}

export function getMapGeocode(params) {
  return axios.get("/v2/store/map/geo/geocode", params);
}

export function getMapReverseGeocode(params) {
  return axios.get("/v2/store/map/geo/reverse", params);
}

export function getLockCodeList(params) {
  return axios.get("/v2/store/wxwork/lockcode/list", params);
}

export function getLockCodeDetail(id) {
  return axios.get(`/v2/store/wxwork/lockcode/${id}/show`);
}

export function createLockCode(params) {
  return axios.post("/v2/store/wxwork/lockcode/create", params);
}

export function updateLockCode(id, params) {
  return axios.post(`/v2/store/wxwork/lockcode/${id}/update`, params);
}

export function deleteLockCode(id) {
  return axios.post(`/v2/store/wxwork/lockcode/${id}/delete`);
}

export function updateLockCodeStatus(id, params) {
  return axios.post(`/v2/store/wxwork/lockcode/${id}/status`, params);
}

export function getLockCodeStats(id, params) {
  return axios.get(`/v2/store/wxwork/lockcode/${id}/stats`, params);
}

export function getLockCodeLogs(id, params) {
  return axios.get(`/v2/store/wxwork/lockcode/${id}/logs`, params);
}

export function unlockLockRelation(id, params) {
  return axios.post(`/v2/store/wxwork/lockcode/${id}/unlock`, params);
}
